/* Crown PDP shared engine (Claude 2026-08-05).
   Multi-section build: the page is composed of independent, reorderable
   `.pdp-crown-sec` sections (theme editor drag-and-drop). This engine loads
   once (guarded), reads its config from a [data-crown-config] JSON blob
   (rendered by the hero + buy sections; first found wins), and feature-detects
   every behaviour so any section can be removed or reordered safely. */
(function () {
  if (window.__crownCoreInit) return;
  window.__crownCoreInit = true;

  function init() {
    var cfgEl = document.querySelector('[data-crown-config]');
    if (!cfgEl) return;
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var WOODS = ['dusk', 'dawn', 'midnight'], ROPES = ['natural', 'charcoal'];
    // Page mode (2026-08-14): 'crown' (default) or 'spin' — the SPINsert PDP
    // renders crown-config with primary:'spin'. Everything product-specific
    // branches off this one const; absent key = crown behaviour unchanged.
    var PRIMARY = CFG.primary === 'spin' ? 'spin' : 'crown';
    var NAME = CFG.name, CROWN_MAP = CFG.crownMap, SHOTS = CFG.shots;
    var LIFESTYLE = CFG.lifestyle, PACKAGING = CFG.packaging;
    var SAVING = CFG.saving, CURRENCY = CFG.currency;
    // Per-finish hero films. Gun Metal has no film yet — falls back to Steel.
    var FILM_SETS = CFG.framesByFinish || {};
    if (CFG.frames && !FILM_SETS.gold) FILM_SETS.gold = CFG.frames;
    function filmFrames(finish) { return FILM_SETS[finish] || FILM_SETS.steel || FILM_SETS.gold || []; }
    var scrubRefresh = null; // set by the scrub engine; called on finish change

    var secs = function () { return document.querySelectorAll('[data-crown-sec]'); };
    var q = function (sel) { return document.querySelector(sel); };
    var qa = function (sel) { return document.querySelectorAll(sel); };

    var state = { finish: 'steel', wood: 'dusk', rope: 'natural', offer: 'bundle', galIdx: 0, buyIdx: 0 };
    try {
      var saved = JSON.parse(localStorage.getItem('crown_cfg_v1') || '{}');
      if (WOODS.indexOf(saved.wood) >= 0) state.wood = saved.wood;
      if (ROPES.indexOf(saved.rope) >= 0) state.rope = saved.rope;
    } catch (e) {}
    // Deep-link offer (2026-08-14): cross-sell links pass ?offer= so "cup
    // alone" / "cap alone" intent survives the hop (bundle stays the default
    // otherwise). Only 'bundle' or this page's own solo offer are honoured.
    try {
      var po = new URLSearchParams(location.search).get('offer');
      if (po === 'bundle' || po === PRIMARY) state.offer = po;
    } catch (e) {}

    function lifeShot() { var c = LIFESTYLE[state.wood + '|' + state.rope]; return c ? c[state.finish] : null; }
    function phLabel(kind) { return NAME[state.wood] + '/' + NAME[state.rope] + '/' + NAME[state.finish] + ' · ' + kind; }
    function fmtLike(sampleStr, amountMinor) {
      var clean = String(sampleStr || '').replace(/<[^>]*>/g, '').trim();
      var sym = (clean.match(/^[^\d\-]+/) || [''])[0].trim();
      if (!sym) sym = ({ GBP: '£', USD: '$', CAD: 'C$', AUD: 'A$', EUR: '€' })[CURRENCY] || '';
      var v = amountMinor / 100;
      var str = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
      return sym + str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function flash(el) {
      if (REDUCED || !el) return;
      el.classList.remove('cl-flash');
      void el.offsetWidth; // restart animation
      el.classList.add('cl-flash');
      clearTimeout(el.__flashT);
      el.__flashT = setTimeout(function () { el.classList.remove('cl-flash'); }, 850);
    }
    function setMedia(slot, src, label) {
      qa('[data-slot="' + slot + '"]').forEach(function (box) {
        var img = box.querySelector('img'), ph = box.querySelector('.cl-ph');
        if (src) {
          box.classList.remove('cl-is-ph');
          if (img.getAttribute('src') !== src) {
            var hadImage = !!img.getAttribute('src');
            img.classList.remove('cl-on');
            img.onload = function () { img.classList.add('cl-on'); };
            img.src = src;
            if (img.complete) img.classList.add('cl-on');
            if (hadImage) flash(box); // luxury glint on every real swap
          } else img.classList.add('cl-on');
        } else if (ph) { box.classList.add('cl-is-ph'); ph.textContent = '[ Placeholder ] ' + label; }
      });
    }
    function buyShots() {
      // Purchase gallery: position 2 is always the giftboxed packaging shot.
      // With the bundle offer selected, position 1 becomes the Crown+SPINsert
      // pair shot for the finish (where photographed — currently gold).
      var l = (SHOTS[state.finish] || []).slice();
      if (l.length >= 2) l[1] = PACKAGING;
      if (l.length) {
        if (state.offer === 'bundle') {
          var pair = (CFG.bundleShots || {})[state.finish];
          if (pair) l[0] = pair;
        } else {
          // soloShots = the primary product alone (spin page); crown page
          // has no soloShots key and falls through to crownShots as before.
          var only = (CFG.soloShots || CFG.crownShots || {})[state.finish];
          if (only) l[0] = only;
        }
        // Position 3 (both offers): the visitor's exact try-on configuration
        // (wood x rope x finish) INSERTED, shifting product shots down.
        var tc = (CFG.tryonShots || {})[state.wood + '|' + state.rope];
        var tshot = tc ? tc[state.finish] : null;
        if (tshot && l.length >= 2) l.splice(2, 0, tshot);
      }
      return l;
    }
    function renderThumbs() {
      var list = SHOTS[state.finish] || [];
      var wrap = q('[data-gal-thumbs]');
      if (wrap) {
        var html = '';
        for (var i = 0; i < list.length; i++) html += '<div class="cl-thumb' + (state.galIdx === i ? ' cl-sel' : '') + '" data-g="' + i + '"><img src="' + list[i] + '" alt="" loading="lazy"></div>';
        var changedG = wrap.__lastHtml !== undefined && wrap.__lastSet !== state.finish;
        wrap.innerHTML = html;
        wrap.__lastHtml = 1; 
        if (changedG && !REDUCED) { wrap.classList.remove('cl-swapfade'); void wrap.offsetWidth; wrap.classList.add('cl-swapfade'); }
        wrap.__lastSet = state.finish;
      }
      var bwrap = q('[data-buy-thumbs]');
      if (bwrap) {
        var blist = buyShots(), h2 = '';
        for (var j = 0; j < blist.length; j++) h2 += '<div class="cl-thumb' + (state.buyIdx === j ? ' cl-sel' : '') + '" data-b="' + j + '"><img src="' + blist[j] + '" alt="" loading="lazy"></div>';
        var keyB = state.finish + '|' + state.offer;
        var changedB = bwrap.__lastKey !== undefined && bwrap.__lastKey !== keyB;
        bwrap.innerHTML = h2;
        if (changedB && !REDUCED) { bwrap.classList.remove('cl-swapfade'); void bwrap.offsetWidth; bwrap.classList.add('cl-swapfade'); }
        bwrap.__lastKey = keyB;
      }
      if (wrap) keepSelVisible(wrap);
      if (bwrap) keepSelVisible(bwrap);
    }
    // On the mobile swipe-strips, keep the highlighted thumb on screen
    function keepSelVisible(strip) {
      if (strip.scrollWidth <= strip.clientWidth + 2) return;
      var sel = strip.querySelector('.cl-sel'); if (!sel) return;
      var r = sel.getBoundingClientRect(), w = strip.getBoundingClientRect();
      if (r.right > w.right) strip.scrollLeft += r.right - w.right + 10;
      else if (r.left < w.left) strip.scrollLeft -= w.left - r.left + 10;
    }
    function render() {
      var f = CROWN_MAP[state.finish]; if (!f) return;
      secs().forEach(function (r) {
        r.setAttribute('data-finish', state.finish);
        r.setAttribute('data-wood', state.wood);
        r.setAttribute('data-rope', state.rope);
      });
      try { localStorage.setItem('crown_cfg_v1', JSON.stringify({ wood: state.wood, rope: state.rope })); } catch (e) {}

      qa('[data-chip-finish]').forEach(function (c) { c.classList.toggle('cl-active', c.getAttribute('data-chip-finish') === state.finish); });
      qa('[data-pick-wood]').forEach(function (c) { c.classList.toggle('cl-active', c.getAttribute('data-pick-wood') === state.wood); });
      qa('[data-pick-rope]').forEach(function (c) { c.classList.toggle('cl-active', c.getAttribute('data-pick-rope') === state.rope); });
      qa('[data-chip-wood]').forEach(function (c) { c.classList.toggle('cl-active', c.getAttribute('data-chip-wood') === state.wood); });
      qa('[data-chip-rope]').forEach(function (c) { c.classList.toggle('cl-active', c.getAttribute('data-chip-rope') === state.rope); });
      qa('[data-view-wood]').forEach(function (e) { e.textContent = NAME[state.wood]; });
      qa('[data-view-rope]').forEach(function (e) { e.textContent = NAME[state.rope]; });
      qa('.cl-cfgdot[data-cycle="wood"]').forEach(function (d) {
        d.setAttribute('data-val', state.wood);
        d.style.backgroundImage = "url('" + CFG.woodSwatch[state.wood] + "')";
        d.title = 'Wood: ' + NAME[state.wood] + '. Click to change';
      });
      qa('.cl-cfgdot[data-cycle="rope"]').forEach(function (d) {
        d.setAttribute('data-val', state.rope);
        d.style.backgroundImage = 'none';
        d.title = 'Rope: ' + NAME[state.rope] + '. Click to change';
      });

      qa('[data-crown-price],[data-crown-price2],[data-crown-price3]').forEach(function (e) { e.textContent = f.crownStr; });
      qa('[data-price-tag]').forEach(function (e) { var s2 = CROWN_MAP[e.getAttribute('data-price-tag')]; if (s2) e.textContent = s2.crownStr; });
      // SPINsert sinks (spinsert-* sections only; zero matches on the crown page)
      qa('[data-spin-price],[data-spin-price2],[data-spin-price3]').forEach(function (e) { e.textContent = f.spinStr; });
      qa('[data-spin-price-tag]').forEach(function (e) { var s3 = CROWN_MAP[e.getAttribute('data-spin-price-tag')]; if (s3) e.textContent = s3.spinStr; });
      qa('[data-fin-name]').forEach(function (e) { e.textContent = f.name; });
      // Task E (2026-08-10): bundle price comes from the metafield target the
      // checkout Function uses (CFG.bundleByFinish, minor units); the legacy
      // flat SAVING is the fallback so the page never shows a broken price.
      var rrp = f.crownPrice + f.spinPrice;
      var bTarget = (CFG.bundleByFinish || {})[state.finish];
      var bundle = (typeof bTarget === 'number' && bTarget > 0 && bTarget < rrp) ? bTarget : rrp - SAVING;
      qa('[data-bundle-price]').forEach(function (e) { e.textContent = fmtLike(f.crownStr, bundle); });
      qa('[data-rrp-price]').forEach(function (e) { e.textContent = fmtLike(f.crownStr, rrp); });
      qa('[data-save-amt]').forEach(function (e) { e.textContent = fmtLike(f.crownStr, rrp - bundle); });

      qa('[data-offer]').forEach(function (o) { o.classList.toggle('cl-sel', o.getAttribute('data-offer') === state.offer); });
      var lblEl = q('[data-atc-label]');
      if (lblEl) lblEl.textContent = state.offer === 'bundle'
        ? ('Add the pair · ' + fmtLike(f.crownStr, bundle))
        : (PRIMARY === 'spin' ? ('Add the SPINsert · ' + f.spinStr) : ('Add the Crown · ' + f.crownStr));

      setMedia('insul', (SHOTS[state.finish] || [])[0], phLabel('product'));
      setMedia('insul-hot', (CFG.hotShots || {})[state.finish] || null, phLabel('hot drink'));
      setMedia('insul-cold', (CFG.coldShots || {})[state.finish] || null, phLabel('cold drink'));
      var asp = CFG.antispill;
      if (asp && typeof asp === 'object') asp = asp[state.finish] || asp.steel || null;
      setMedia('lip', asp || null, phLabel('anti-spill lip macro'));
      setMedia('brushed', (CFG.brushedShots || {})[state.finish] || null, phLabel('polished vs brushed'));
      setMedia('medal', (SHOTS[state.finish] || [])[2], phLabel('medallion'));
      var tcombo = (CFG.tryonShots || {})[state.wood + '|' + state.rope];
      setMedia('tryon', tcombo ? tcombo[state.finish] : null, phLabel('on your CHUUG'));
      var tname = (CFG.tryonNames || {})[state.wood + '|' + state.rope + '|' + state.finish];
      qa('[data-tryon-name]').forEach(function (e) { e.textContent = tname ? '\u2018' + tname + '\u2019' : ''; });
      setMedia('galmain', (SHOTS[state.finish] || [])[state.galIdx], phLabel('product'));
      setMedia('buymain', buyShots()[state.buyIdx], phLabel('product'));
      setMedia('heromain', (SHOTS[state.finish] || [])[0], phLabel('product')); // static hero (spin page)
      renderThumbs();
      if (scrubRefresh) scrubRefresh();
    }

    // Delegated events (document level so section order never matters)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-crown-sec]')) return;
      var t;
      if ((t = e.target.closest('[data-set-finish]'))) { state.finish = t.getAttribute('data-set-finish'); state.galIdx = 0; state.buyIdx = 0; render(); return; }
      if ((t = e.target.closest('[data-chip-finish]'))) { state.finish = t.getAttribute('data-chip-finish'); state.galIdx = 0; state.buyIdx = 0; render(); return; }
      if ((t = e.target.closest('[data-pick-wood]'))) { state.wood = t.getAttribute('data-pick-wood'); render(); return; }
      if ((t = e.target.closest('[data-pick-rope]'))) { state.rope = t.getAttribute('data-pick-rope'); render(); return; }
      if ((t = e.target.closest('[data-chip-wood]'))) { state.wood = t.getAttribute('data-chip-wood'); render(); return; }
      if ((t = e.target.closest('[data-chip-rope]'))) { state.rope = t.getAttribute('data-chip-rope'); render(); return; }
      if ((t = e.target.closest('.cl-cfgdot'))) {
        var k = t.getAttribute('data-cycle');
        if (k === 'wood') state.wood = WOODS[(WOODS.indexOf(state.wood) + 1) % WOODS.length];
        else state.rope = ROPES[(ROPES.indexOf(state.rope) + 1) % ROPES.length];
        render(); return;
      }
      if ((t = e.target.closest('[data-g]'))) { state.galIdx = parseInt(t.getAttribute('data-g'), 10); render(); return; }
      if ((t = e.target.closest('[data-b]'))) { state.buyIdx = parseInt(t.getAttribute('data-b'), 10); render(); return; }
      if ((t = e.target.closest('[data-offer]'))) { state.offer = t.getAttribute('data-offer'); render(); return; }
      if ((t = e.target.closest('[data-scroll-buy]'))) {
        e.preventDefault();
        var buy = document.getElementById('crown-buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    });
    // Swipe the main purchase / gallery image to step through the shots
    var swx = 0, swy = 0, swipeSlot = null;
    document.addEventListener('touchstart', function (e) {
      var m = e.target.closest('[data-slot="buymain"],[data-slot="galmain"]');
      swipeSlot = m ? m.getAttribute('data-slot') : null;
      if (!m) return;
      swx = e.touches[0].clientX; swy = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!swipeSlot) return;
      var slot = swipeSlot; swipeSlot = null;
      var dx = e.changedTouches[0].clientX - swx, dy = e.changedTouches[0].clientY - swy;
      if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      var list = slot === 'buymain' ? buyShots() : (SHOTS[state.finish] || []);
      var n = list.length; if (n < 2) return;
      var step = dx < 0 ? 1 : n - 1;
      if (slot === 'buymain') state.buyIdx = (state.buyIdx + step) % n;
      else state.galIdx = (state.galIdx + step) % n;
      render();
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!e.target.closest || !e.target.closest('[data-crown-sec]')) return;
      var t = e.target.closest('[data-chip-finish],[data-chip-wood],[data-chip-rope],[data-pick-wood],[data-pick-rope],[data-offer],.cl-cfgdot,[data-set-finish]');
      if (t) { e.preventDefault(); t.click(); }
    });

    // Add to cart (purchase section only)
    function stamp() { return 'crown-' + Math.floor(Math.random() * 1e9).toString(36); }
    function addItems(items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
    }
    function go() { window.location.href = CFG.cartUrl || '/cart'; }
    var atcBtn = q('[data-atc]');
    if (atcBtn) atcBtn.addEventListener('click', function () {
      var f = CROWN_MAP[state.finish];
      // Availability gates follow the page's primary product; the bundle
      // additionally needs the companion. Line items are identical either
      // way, so the checkout Function's bundle discount is unaffected.
      if (!f || (PRIMARY === 'spin' ? !f.spinAvail : !f.crownAvail)) return;
      atcBtn.disabled = true; atcBtn.style.opacity = '.6';
      var s = stamp(), fail = function () { atcBtn.disabled = false; atcBtn.style.opacity = ''; alert('Sorry, we could not add that to your basket. Please try again.'); };
      var companionAvail = PRIMARY === 'spin' ? f.crownAvail : f.spinAvail;
      if (state.offer === 'bundle' && companionAvail) {
        var pc = { '_cart_unique': s + '-c', 'Finish': f.name, '_bundle': s };
        var ps = { '_cart_unique': s + '-s', 'Finish': f.name, '_bundle': s };
        addItems([{ id: f.crownId, quantity: 1, properties: pc }, { id: f.spinId, quantity: 1, properties: ps }])
          .then(go).catch(function () {
            addItems([{ id: f.crownId, quantity: 1, properties: pc }])
              .then(function () { return addItems([{ id: f.spinId, quantity: 1, properties: ps }]); })
              .then(go).catch(fail);
          });
      } else if (PRIMARY === 'spin') {
        addItems([{ id: f.spinId, quantity: 1, properties: { '_cart_unique': s + '-s', 'Finish': f.name } }]).then(go).catch(fail);
      } else {
        addItems([{ id: f.crownId, quantity: 1, properties: { '_cart_unique': s + '-c', 'Finish': f.name } }]).then(go).catch(fail);
      }
    });

    // Scroll film (hero section) — finish-aware: each finish has its own
    // frame set (gunmetal falls back to steel); switching finish swaps the
    // film in place at the same scroll progress.
    (function () {
      var wrap = q('[data-scrub]'); if (!wrap) return;
      var canvas = wrap.querySelector('canvas'); if (!canvas) return;
      var heroContent = wrap.querySelector('[data-hero-content]');
      var ctx = canvas.getContext('2d');
      if (!filmFrames(state.finish).length) return;
      var cache = {};            // src -> { img, ready }
      var progress = 0, drawnSrc = null;
      function entry(src) {
        var e = cache[src];
        if (!e) {
          e = cache[src] = { img: new Image(), ready: false };
          e.img.decoding = 'async';
          e.img.onload = function () { e.ready = true; maybeRedraw(src); };
          e.img.src = src;
        }
        return e;
      }
      function curIndex(frames) { return Math.min(frames.length - 1, Math.round(progress * (frames.length - 1))); }
      function maybeRedraw(loadedSrc) {
        var frames = filmFrames(state.finish);
        var want = frames[curIndex(frames)];
        if (loadedSrc === want && drawnSrc !== want) draw();
      }
      function draw() {
        var frames = filmFrames(state.finish);
        if (!frames.length) return;
        var i = curIndex(frames);
        var e = entry(frames[i]);
        if (!e.ready) {
          // nearest loaded frame in this set
          for (var d = 1; d < frames.length; d++) {
            var lo = cache[frames[i - d]], hi = cache[frames[i + d]];
            if (lo && lo.ready) { e = lo; break; }
            if (hi && hi.ready) { e = hi; break; }
          }
          if (!e.ready) return;
        }
        ctx.drawImage(e.img, 0, 0, canvas.width, canvas.height);
        drawnSrc = e.img.src;
      }
      function pumpSet(finish) {
        var frames = filmFrames(finish);
        var i = 0;
        (function pump() {
          if (i < frames.length) { entry(frames[i++]); setTimeout(pump, 50); }
        })();
      }
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      entry(filmFrames(state.finish)[0]);
      if (reduced) { draw(); return; }
      pumpSet(state.finish);
      var pumped = {}; pumped[state.finish] = true;
      var lastFilmFinish = state.finish;
      scrubRefresh = function () {
        // finish changed: pump its set once, redraw at current progress
        var key = filmFrames(state.finish) === FILM_SETS[state.finish] ? state.finish : 'steel';
        if (!pumped[key]) { pumped[key] = true; pumpSet(state.finish); }
        if (lastFilmFinish !== state.finish) {
          lastFilmFinish = state.finish;
          flash(wrap.querySelector('.cl-scrub-sticky'));
        }
        draw();
      };
      var ticking = false;
      function onScrub() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var total = wrap.offsetHeight - window.innerHeight;
          var p = total > 0 ? (-wrap.getBoundingClientRect().top) / total : 0;
          progress = Math.min(1, Math.max(0, p));
          draw();
          if (heroContent) {
            var cp = Math.min(1, progress / 0.28);
            heroContent.style.transform = 'translateY(' + (-cp * 60) + 'vh)';
            heroContent.style.opacity = String(1 - cp);
            heroContent.style.pointerEvents = cp >= 0.98 ? 'none' : '';
          }
        });
      }
      window.addEventListener('scroll', onScrub, { passive: true });
      window.addEventListener('resize', onScrub);
      onScrub();
    })();

    // ── Out of stock: "Notify me when it's in" modal (Claude 2026-08-14) ──
    // Active only when the purchase section renders with data-oos (theme
    // setting). The modal lives inside [data-crown-sec], so its finish chips
    // and offer rows ride the existing delegated clicks + render() sync —
    // this module only handles open/close, validation and the submit POST
    // to the Mission Control public endpoint.
    (function () {
      if (!q('[data-crown-sec][data-oos]')) return;
      // All handlers are document-delegated and resolve nodes at event time,
      // so the module survives theme-editor section re-renders
      // (shopify:section:load replaces the DOM but __crownCoreInit blocks a
      // re-init — captured node references would go stale).
      var lastFocus = null, busy = false;
      function modal() { return q('[data-oos-modal]'); }

      function openModal() {
        var m = modal(); if (!m) return;
        lastFocus = document.activeElement;
        m.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var target = window.matchMedia && window.matchMedia('(max-width:640px)').matches
          ? m.querySelector('.cl-oos-x') : m.querySelector('input[name="email"]');
        if (target) target.focus();
      }
      function closeModal() {
        var m = modal(); if (!m) return;
        m.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-oos-open]')) { openModal(); return; }
        if (e.target.closest('[data-oos-close]')) { closeModal(); return; }
      });
      document.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-oos-cc]');
        if (!sel) return;
        var m = modal(); if (!m) return;
        var other = m.querySelector('[data-oos-cc-other]');
        other.hidden = sel.value !== 'other';
        if (sel.value === 'other') other.focus();
      });
      document.addEventListener('keydown', function (e) {
        var m = modal();
        if (!m || m.hidden) return;
        if (e.key === 'Escape') { closeModal(); return; }
        if (e.key === 'Tab') {
          // Minimal focus trap: keep Tab cycling inside the card.
          var card = m.querySelector('.cl-oos-card');
          var focusables = card.querySelectorAll('button, input, select, [tabindex="0"]');
          var list = [];
          for (var i = 0; i < focusables.length; i++) {
            if (!focusables[i].hidden && focusables[i].offsetParent !== null) list.push(focusables[i]);
          }
          if (!list.length) return;
          var first = list[0], last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      function showErr(m, msg) {
        var el = m.querySelector('[data-oos-error]');
        if (el) { el.textContent = msg; el.hidden = false; }
      }
      function clearErr(m) {
        var el = m.querySelector('[data-oos-error]');
        if (el) { el.textContent = ''; el.hidden = true; }
      }
      function showSuccess(m) {
        var form = m.querySelector('[data-oos-form]');
        var config = m.querySelector('.cl-oos-config');
        var success = m.querySelector('[data-oos-success]');
        if (form) form.hidden = true;
        if (config) config.hidden = true;
        if (success) {
          success.hidden = false;
          var done = success.querySelector('[data-oos-close]');
          if (done) done.focus();
        }
      }
      // Mirrors the server's rules: E.164 composed from dial code + national
      // number (leading zeros stripped). '' = not provided, null = invalid.
      function composedWhatsapp(m) {
        var natInput = m.querySelector('[data-oos-nat]');
        var ccSel = m.querySelector('[data-oos-cc]');
        var ccOther = m.querySelector('[data-oos-cc-other]');
        var nat = ((natInput && natInput.value) || '').replace(/[\s().-]/g, '');
        if (!nat) return '';
        var code = ccSel && ccSel.value === 'other' ? ((ccOther && ccOther.value) || '') : ((ccSel && ccSel.value) || '');
        code = code.replace(/[^\d+]/g, '');
        if (code && code.charAt(0) !== '+') code = '+' + code;
        nat = nat.replace(/^0+/, '');
        if (!/^\+[1-9]\d{0,3}$/.test(code) || !/^\d+$/.test(nat)) return null;
        var full = code + nat;
        return /^\+[1-9]\d{7,14}$/.test(full) ? full : null;
      }
      function cleanEmail(m) {
        var input = m.querySelector('input[name="email"]');
        var v = ((input && input.value) || '').trim().toLowerCase();
        if (!v) return '';
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? v : null;
      }

      document.addEventListener('submit', function (e) {
        if (!e.target.closest || !e.target.closest('[data-oos-form]')) return;
        e.preventDefault();
        if (busy) return;
        var m = modal(); if (!m) return;
        var root = q('[data-crown-sec][data-oos]'); if (!root) return;
        clearErr(m);
        var email = cleanEmail(m);
        var whatsapp = composedWhatsapp(m);
        if (email === null) { showErr(m, 'That email address doesn’t look right.'); return; }
        if (whatsapp === null) { showErr(m, 'That WhatsApp number doesn’t look right — check the country code and number.'); return; }
        if (!email && !whatsapp) { showErr(m, 'Add an email address or a WhatsApp number — either works.'); return; }

        // Theme editor preview: never create real registrations from there.
        if (window.Shopify && Shopify.designMode) { showSuccess(m); return; }

        var f = CROWN_MAP[state.finish] || {};
        var rrp = (f.crownPrice || 0) + (f.spinPrice || 0);
        var bTarget = (CFG.bundleByFinish || {})[state.finish];
        var bundle = (typeof bTarget === 'number' && bTarget > 0 && bTarget < rrp) ? bTarget : rrp - SAVING;
        var hpInput = m.querySelector('[data-oos-hp]');
        // Offer-aware variants: solo registrations carry only their own
        // product's id; bundle carries both. On the crown page state.offer
        // is only ever 'crown'|'bundle', so these match the original values.
        var payload = {
          email: email || null,
          whatsapp: whatsapp || null,
          finish: state.finish,
          finish_name: f.name || state.finish,
          offer: state.offer,
          crown_variant_id: state.offer !== 'spin' && f.crownId ? String(f.crownId) : null,
          spin_variant_id: state.offer !== 'crown' && f.spinId ? String(f.spinId) : null,
          currency: CURRENCY || null,
          price_minor: state.offer === 'bundle' ? bundle : (PRIMARY === 'spin' ? (f.spinPrice || null) : (f.crownPrice || null)),
          quoted_label: root.getAttribute('data-oos-label') || '',
          page: location.pathname,
          source: PRIMARY === 'spin' ? 'spinsert-pdp' : 'crown-pdp',
          // Conversion Tracking (2026-09-11): tie the registration to the
          // page-view session recorded by assets/chuug-ct.js.
          session_id: window.__ctSession || null,
          hp: hpInput ? hpInput.value : ''
        };

        busy = true;
        var submitBtn = m.querySelector('[data-oos-submit]');
        if (submitBtn) submitBtn.disabled = true;
        var btnSpan = submitBtn && submitBtn.querySelector('span');
        var btnText = btnSpan ? btnSpan.textContent : '';
        if (btnSpan) btnSpan.textContent = 'Sending…';
        function fail(msg) {
          busy = false;
          if (submitBtn) submitBtn.disabled = false;
          if (btnSpan) btnSpan.textContent = btnText;
          showErr(m, msg);
        }
        // text/plain keeps this a CORS simple request (no preflight) — the
        // endpoint parses the body as JSON regardless of content type.
        fetch(root.getAttribute('data-oos-endpoint') || '', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload),
          credentials: 'omit',
          keepalive: true
        }).then(function (r) {
          if (r.status === 429) { fail('Too many requests from your connection — please try again later.'); return null; }
          return r.json().catch(function () { return {}; }).then(function (b) {
            if (r.ok && b && b.ok) { showSuccess(m); }
            else { fail('Something went wrong — please try again.'); }
          });
        }).catch(function () { fail('Something went wrong — please check your connection and try again.'); });
      });
    })();

    // Sticky mini bar: after the hero film, hidden while purchase section visible
    (function () {
      // Film-less pages (SPINsert) mark their hero with [data-static-hero]
      // so the mini bar still waits for the hero to scroll off.
      var hero = q('[data-scrub]') || q('[data-static-hero]'), buy = document.getElementById('crown-buy'), sticky = q('[data-sticky]');
      if (!sticky || !('IntersectionObserver' in window)) return;
      var heroOff = !hero, buyOn = false;
      var update = function () { sticky.classList.toggle('cl-show', heroOff && !buyOn); };
      if (hero) new IntersectionObserver(function (es) { es.forEach(function (en) { heroOff = !en.isIntersecting; }); update(); }).observe(hero);
      if (buy) new IntersectionObserver(function (es) { es.forEach(function (en) { buyOn = en.isIntersecting; }); update(); }).observe(buy);
    })();

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
